export const blockIconsPlacesFoundation = (
	<span className='material-symbols-outlined'>foundation</span>
);
